import axios from 'axios';
import api from '@/utils/api';
import api_login from '@/utils/api_login';
import api_login_from_acc_center from '@/utils/api_login_from_acc_center';

Date.prototype.addHours = function (h) {
    this.setTime(this.getTime() + h * 60 * 60 * 1000);
    return this;
};

const state = {
    authStatus: '',
    company: localStorage.getItem('company') || '',
    expiredTime: localStorage.getItem('expiredTime') || '',
    token: localStorage.getItem('token') || '',
    email: localStorage.getItem('email') || '',
    sno: localStorage.getItem('sno') || '',
    name: localStorage.getItem('name') || '',
    untList: localStorage.getItem('untList') || '',
    isAdmin: localStorage.getItem('isAdmin') == 'true' || false,
    pdT_TYP: localStorage.getItem('pdT_TYP') || null,
    grP_NO: localStorage.getItem('grP_NO') || null,
    employee: localStorage.getItem('employee') || null,
};

const getters = {
    // 登出時間
    expiredTime: (state) => state.expiredTime,

    // 公司ID
    company: (state) => state.company,

    // 使用者 email
    email: (state) => state.email,

    // 確認是否登入
    isLoggedIn: (state) => {
        // 同時有 token 且未到登出時間
        if (!!state.token && state.expiredTime > Date.now()) {
            return true;
        }
        return false;
    },

    userSno: (state) => Number(state.sno),

    // 名稱
    userName: (state) => state.name,

    // 權限清單
    untList: (state) => {
        if (state.untList.split) return state.untList.split(',');
        return state.untList;
    },

    // 是否有管理員權限
    isAdmin: (state) => state.isAdmin,

    // 角色群組
    userGrP_NO: (state) => state.grP_NO,

    // 是否為財務專員
    isSAAdmin: (state) => state.grP_NO === 'SA',

    // 是否為帳號管理員
    isAccAdmin: (state) => state.grP_NO === 'ADM',

    // 是否為 Ahoo 專員
    isAhooAgent: (state) => state.grP_NO === 'INI',

    // 是否為財務顧問
    isPFAgent: (state) => state.grP_NO === 'PF',

    // 是否為 會計專區帳號
    isAccountingUser: (state) => state.grP_NO.slice(0, 2) === 'OT',

    // 登入認證狀態
    authStatus: (state) => state.status,

    // 訂購方案
    pdT_TYP: (state) => state.pdT_TYP,

    // 是否為公司內部員工
    employee: (state) => state.employee,
};

const actions = {
    // 登入
    login({ commit }, user) {
        function generateUUID() {
            return 'xxxx-xxxx-4xxx-yxxx-xxxx'.replace(/[xy]/g, (c) => {
                const r = (Math.random() * 16) | 0;
                const v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        }

        function getDeviceCode() {
            let code = localStorage.getItem('device_code');
            if (code) {
                return code;
            }
            code = generateUUID();
            localStorage.setItem('device_code', code);
            return code;
        }

        return new Promise((resolve, reject) => {
            commit('auth_request');

            const usr = {
                eml: user.email,
                pwd: user.password,
                cmp: user.company,
                logiN_CODE: getDeviceCode(),
            };

            api_login({
                url: 'LoginPage/Login',
                data: usr,
                method: 'POST',
                timeout: 10 * 1000,
            })
                // 登入成功
                .then((resp) => {
                    console.log('login data', resp);

                    const { token } = resp.data.loginInfo;
                    // const expiredTime = resp.data.loginInfo.expiredTime
                    const expiredTime = new Date().getTime() + 1060 * 60 * 1000;
                    const { email } = user;
                    const { company } = user;
                    const { sno } = resp.data.loginInfo;
                    const name = resp.data.loginInfo.nam;
                    const { untList } = resp.data.loginInfo;
                    const { grP_NO } = resp.data.loginInfo;
                    const isAdmin = resp.data.loginInfo.adm === 1;
                    const { pdT_TYP } = resp.data.loginInfo;
                    const { employee } = resp.data.loginInfo;

                    // 紀錄 token 到 localStorage
                    localStorage.setItem('token', token);
                    localStorage.setItem('expiredTime', expiredTime);
                    localStorage.setItem('company', user.company);
                    localStorage.setItem('email', user.email);
                    localStorage.setItem('sno', sno);
                    localStorage.setItem('name', name);
                    localStorage.setItem('untList', untList);
                    localStorage.setItem('grP_NO', grP_NO);
                    localStorage.setItem('isAdmin', isAdmin);
                    localStorage.setItem('pdT_TYP', pdT_TYP);
                    localStorage.setItem('employee', employee);

                    // 設回
                    localStorage.removeItem('indexTab');

                    // 紀錄 token 到 axios 的 Header 供之後 api 使用
                    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
                    commit('auth_success', {
                        token,
                        expiredTime,
                        company,
                        email,
                        sno,
                        name,
                        untList,
                        isAdmin,
                        pdT_TYP,
                        grP_NO,
                        employee,
                    });
                    resolve(resp);
                })

                // 登入失敗
                .catch((err) => {
                    commit('auth_error');
                    localStorage.removeItem('token');
                    reject(err);
                });
        });
    },

    // 從會計服務專區登入
    async loginFromAccCenter({ commit }, { mno, cryptoToken }) {
        commit('auth_request');

        const resp = await api_login_from_acc_center({
            url: 'LoginPage/LoginByAccountingServiceToken',
            data: { mno, token: cryptoToken },
            method: 'POST',
            timeout: 10 * 1000,
        });
        try {
            // 登入成功

            console.log('login from acc data', resp);

            const { token } = resp.data.loginInfo;
            // const expiredTime = resp.data.loginInfo.expiredTime
            const expiredTime = new Date().getTime() + 1060 * 60 * 1000;
            const { eml } = resp.data.loginInfo;
            const { cmp } = resp.data.loginInfo;
            const { bsn } = resp.data.loginInfo;
            const { sno } = resp.data.loginInfo;
            const name = resp.data.loginInfo.nam;
            const { untList } = resp.data.loginInfo;
            const { grP_NO } = resp.data.loginInfo;
            const isAdmin = resp.data.loginInfo.adm === 1;
            const { pdT_TYP } = resp.data.loginInfo;
            const { employee } = resp.data.loginInfo;

            // 紀錄 token 到 localStorage
            localStorage.setItem('token', token);
            localStorage.setItem('expiredTime', expiredTime);
            localStorage.setItem('company', cmp);
            localStorage.setItem('accLoginBsn', bsn);
            localStorage.setItem('email', eml);
            localStorage.setItem('sno', sno);
            localStorage.setItem('name', name);
            localStorage.setItem('untList', untList);
            localStorage.setItem('grP_NO', grP_NO);
            localStorage.setItem('isAdmin', isAdmin);
            localStorage.setItem('pdT_TYP', pdT_TYP);
            localStorage.setItem('employee', employee);

            // 設回
            localStorage.removeItem('indexTab');

            // 紀錄 token 到 axios 的 Header 供之後 api 使用
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            commit('auth_success', {
                token,
                expiredTime,
                cmp,
                eml,
                sno,
                name,
                untList,
                isAdmin,
                pdT_TYP,
                grP_NO,
                employee,
            });

            console.log('ccccccc');
        } catch (err) {
            // 登入失敗
            commit('auth_error');
            localStorage.removeItem('token');
        }
    },

    // 登出
    logout({ commit }) {
        return new Promise((resolve, reject) => {
            commit('logout');
            this.dispatch('menu/logoutMenu');
            localStorage.removeItem('token');
            localStorage.removeItem('expiredTime');
            localStorage.removeItem('accLoginBsn');
            delete axios.defaults.headers.common.Authorization;
            resolve();
            reject();
        });
    },

    // 延長登入時間(renew token)
    extendExpiredTime({ commit }) {
        return new Promise((resolve, reject) => {
            api({
                url: 'Layout/ResetToken',
                data: null,
                method: 'POST',
            })
                // 成功
                .then((resp) => {
                    console.log('token renewed');

                    const { token } = resp.data.loginInfo;
                    // const expiredTime = resp.data.loginInfo.expiredTime
                    // const expiredTime = new Date().addHours(4).getTime()
                    const expiredTime = new Date().getTime() + 1060 * 60 * 1000;

                    // 紀錄 token 到 localStorage
                    localStorage.setItem('token', token);
                    localStorage.setItem('expiredTime', expiredTime);

                    // 紀錄 token 到 axios 的 Header 供之後 api 使用
                    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
                    commit('auth_renew_success', { token, expiredTime });
                    resolve(resp);
                })

                // 登入失敗
                .catch((err) => {
                    commit('auth_error');
                    localStorage.removeItem('token');
                    reject(err);
                });
        });
    },
};

const mutations = {
    auth_request(state) {
        state.authStatus = 'loading';
    },
    auth_success(state, {
        token, expiredTime, company, email, sno, name, untList, isAdmin, pdT_TYP, grP_NO, employee,
    }) {
        state.authStatus = 'success';
        state.token = token;
        state.expiredTime = expiredTime;
        state.company = company;
        state.email = email;
        state.name = name;
        state.sno = sno;
        state.untList = untList;
        state.isAdmin = isAdmin;
        state.pdT_TYP = pdT_TYP;
        state.grP_NO = grP_NO;
        state.employee = employee;
    },
    auth_renew_success(state, { token, expiredTime }) {
        state.authStatus = 'success';
        state.token = token;
        state.expiredTime = expiredTime;
    },
    auth_error(state) {
        state.authStatus = 'error';
    },
    logout(state) {
        state.authStatus = '';
        state.token = '';
        state.expiredTime = '';
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
